import { IChartData, IDashboardDimensionsViewModel, Filters } from "../plotdata";

//Actions / requests
export enum WorkerRequestType { Ping, Fetch, ChartData }
export interface IWorkerFetchRequest { all: boolean, rawRefs: any, rawRows: string, minYear: number }
export interface IWorkerChartDataRequest { filtersToApply: Filters, minYear: number };
export interface IWorkerRequest {
    type: WorkerRequestType;
    id: string;
    payload?: any; //?
}

//Results
export enum WorkerResultType { Ping, Fetch, ChartData, InvalidType }
export interface IWorkerResult {
    type: WorkerResultType;
    id: string;
    payload?: any; //?
}
export interface IWorkerPingResult {}
export interface IWorkerFetchResult { allData: boolean, references: IDashboardDimensionsViewModel, chartData: IChartData }
export type IWorkerChartDataResult = IChartData;